export interface PerformanceData {
  pageLoad: number | null;
  domContentLoaded: number | null;
  firstContentfulPaint: number | null;
  longTasks: number;
  memoryUsed: number | null;
}

let longTaskCount = 0;
let observer: PerformanceObserver | null = null;

export function startPerformanceCollector(): void {
  // Long tasks observer
  try {
    observer = new PerformanceObserver((list) => {
      longTaskCount += list.getEntries().length;
    });
    observer.observe({ type: 'longtask', buffered: true });
  } catch {
    // PerformanceObserver for longtask not supported
  }
}

export function stopPerformanceCollector(): void {
  if (observer) {
    observer.disconnect();
    observer = null;
  }
}

export function getPerformanceData(): PerformanceData {
  let pageLoad: number | null = null;
  let domContentLoaded: number | null = null;
  let firstContentfulPaint: number | null = null;
  let memoryUsed: number | null = null;

  // Navigation timing
  const navEntries = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
  if (navEntries.length > 0) {
    const nav = navEntries[0];
    pageLoad = Math.round(nav.loadEventEnd - nav.startTime);
    domContentLoaded = Math.round(nav.domContentLoadedEventEnd - nav.startTime);
  }

  // First Contentful Paint
  const paintEntries = performance.getEntriesByType('paint');
  for (const entry of paintEntries) {
    if (entry.name === 'first-contentful-paint') {
      firstContentfulPaint = Math.round(entry.startTime);
    }
  }

  // Memory (Chrome only)
  const perfWithMemory = performance as Performance & {
    memory?: { usedJSHeapSize: number };
  };
  if (perfWithMemory.memory) {
    memoryUsed = perfWithMemory.memory.usedJSHeapSize;
  }

  return {
    pageLoad: pageLoad && pageLoad > 0 ? pageLoad : null,
    domContentLoaded: domContentLoaded && domContentLoaded > 0 ? domContentLoaded : null,
    firstContentfulPaint,
    longTasks: longTaskCount,
    memoryUsed,
  };
}
